export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const REMOVE_CART = "REMOVE_CART";
export const QTY = "QTY";
export const CURRENT_CART = "CURRENT_CART";
export const SET_PRODUCTS = "SET_PRODUCTS";
